import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import { MembershipTypeStore } from '@seedlang/stores';
import Paginator from 'components/paginator';
import DeleteButton from 'components/button/delete_button';
import MembershipTypeCreate from './membership_type_create';
import autobind from 'autobind-decorator';
import { Link } from 'react-router';
import InPlaceText from 'components/form/in_place_text';
import Cookies from 'js-cookie';
import styled from '@emotion/styled';
import Spinner from 'components/spinner';
import PageTitle from 'components/common/page_title';

const Note = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  margin-top: 10px;
`;

@observer
class SiteMembershipTypeIndex extends React.Component {

  componentDidMount() {
    this.loadMembershipTypes();
  }

  @autobind onDelete(id) {
    MembershipTypeStore.destroy({ids: {membershipTypeId: id}});
  }

  @autobind loadMembershipTypes() {
    MembershipTypeStore.getIndex();
  }

  @computed get filteredMembershipTypes() {
    const siteId = Cookies.get('site_id');

    return MembershipTypeStore.indexData.filter(item => item.siteId === siteId);
  }

  @autobind isDeletable(membershipType) {
    return membershipType.userCount === 0;
  }

  render() {
    return (
      <div className='builder-membership-type-index'>
        <PageTitle>Membership Types</PageTitle>
        <MembershipTypeCreate />
            {
              MembershipTypeStore.hasOutstandingRequests &&
                <Spinner />
            }
            <table className='table-wrapper admin-table'>
              <thead>
                <tr>
                  <th width='20' />
                  <th>Pos</th>
                  <th>Name</th>
                  <th>Slug</th>
                  <th>Users</th>
                  <th width='40'></th>
                </tr>
              </thead>
              <tbody>
                {
                  this.filteredMembershipTypes.map(item => {
                    return (
                      <tr key={item.id}>
                        <td>
                          <Link
                            to={{ name: 'creator.membership_types.edit', params: { membershipTypeId: item.id } }}
                            className='on-click'
                          >
                            <i className='fa fa-chevron-right fa-block' />
                          </Link>
                        </td>
                        <td>
                          <InPlaceText
                            id={item.id}
                            defaultValue={item.position}
                            model='membership_types'
                            field='position'
                            type='number'
                            step='1'
                            afterChange={this.loadMembershipTypes}
                          />
                        </td>
                        <td>
                          <div className='text'>
                            {item.name}
                          </div>
                        </td>
                        <td>
                          <div className='text'>
                            {item.slug}
                          </div>
                        </td>
                        <td>
                          <div className='text'>
                            {item.userCount}
                          </div>
                        </td>
                        <td>
                          <DeleteButton
                            onConfirm={() => this.onDelete(item.id)}
                            message={
                              this.isDeletable(item)
                                ? 'Delete this Payment Plan?'
                                : 'Cannot delete this Payment Plan while users are assigned to it'
                            }
                            className='fa-block right'
                            showTooltip={!this.isDeletable(item)}
                            disabled={!this.isDeletable(item)}
                          />
                        </td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
            <Paginator
              store={MembershipTypeStore}
            />
            <Note>
              Note: this page is only meant for setting up membership types. Please use the <a href='/creator/membership_groups' className='underline'>Membership Groups</a> page to manage which membership groups are currently visible on the site.
            </Note>
      </div>
    );
  }
}

export default SiteMembershipTypeIndex;
